import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthApiService } from '../../../services/apis/auth-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { MessageService } from '../../../services/message.service';
import { validateFormGroup } from '../../../utils/form';
import { Button } from '../../common/button/button';
import { GoogleRecaptchaComponent } from '../../common/google-recaptcha/google-recaptcha.component';
declare let grecaptcha: any;

@Component({
  selector: 'app-send-reset-password-email-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleRecaptchaComponent,
    Button,
  ],
  templateUrl: './send-reset-password-email-dialog.component.html',
  styleUrl: './send-reset-password-email-dialog.component.scss',
})
export class SendResetPasswordEmailDialogComponent {
  formGroup: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SendResetPasswordEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: string,
    private fb: FormBuilder,
    private authApi: AuthApiService,
    private messageService: MessageService,
    private router: Router
  ) {
    this.formGroup = this.fb.group({
      email: [data || '', [Validators.required, Validators.email]],
    });
  }

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  onSend() {
    if (this.loading) {
      return;
    }
    const values = validateFormGroup(this.formGroup);
    if (!values) {
      return;
    }
    const token = grecaptcha.getResponse();
    if (!token) {
      this.messageService.open(
        'Please complete the CAPTCHA to verify you are not a robot.',
        'OK'
      );
      return;
    }
    this.sendResetPasswordEmail(values.email, token);
  }

  loading = false;
  async sendResetPasswordEmail(email: string, token: string) {
    try {
      this.loading = true;
      const r = await this.authApi.sendResetPasswordEmail({ email, token });
      if (r) {
        this.messageService.open('Reset password email sent', 'OK');
        this.close();
      } else {
        this.messageService.open(
          'Email send failed, please try again later',
          'OK'
        );
      }
    } catch (error) {
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.RECAPTCHA_TOKEN_FAILED) {
          this.messageService.open('Please complete the CAPTCHA', 'OK');
          grecaptcha?.reset();
        } else if (error.status === ApiStatus.USER_EMAIL_NOT_FOUND) {
          this.messageService
            .open('This email is not registered', 'Signup')
            ?.onAction()
            .subscribe(() => {
              this.close();
              this.router.navigate(['/signup']);
            });
        } else if (error.status === ApiStatus.USER_EMAIL_SEND_TOO_FREQUENTLY) {
          this.messageService.open(
            'Email sent too frequently, please try again later',
            'OK'
          );
        } else if (error.status !== ApiStatus.OK) {
          this.messageService.open('Unknown Error', 'OK');
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
